let isFavicon = false; // Track current logo state

document.addEventListener('scroll', function() {
    const logo = document.querySelector('.header__heading-logo');
    const scrollPosition = window.scrollY;

    // Check if we need to swap logo
    if (scrollPosition > 100 && !isFavicon) {
        // Add fade class for animation
        logo.classList.add('fade');

        setTimeout(() => {
            logo.src = 'https://yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Submark-1.png?crop=center&height=50&v=1746685608&width=50';
            logo.srcset = '';
            logo.width = '50';
            logo.height = '50';
            logo.sizes = '50px';
            logo.classList.remove('fade');
            isFavicon = true; // Update state
        }, 300); // Match with CSS transition duration
    } else if (scrollPosition <= 100 && isFavicon) {
        // Add fade class for animation
        logo.classList.add('fade');

        setTimeout(() => {
            logo.src = '//yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=600';
            logo.srcset = '//yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=100 100w, //yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=150 150w, //yarnenfashion.myshopify.com/cdn/shop/files/Yarnen-Logo.png?v=1746508789&width=200 200w';
            logo.width = '100';
            logo.height = '44.61538461538462';
            logo.sizes = '(min-width: 750px) 100px, 50vw';
            logo.classList.remove('fade');
            isFavicon = false; // Update state
        }, 300); // Match with CSS transition duration
    }
});






// banner slider sections  js 
document.addEventListener('DOMContentLoaded', function() {
    const mobileWidth = 768;
    const slides = [
      {
            id: 'Slide-template--24335250194711__slideshow_r397Hj-1',
            mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/Yarnen_Banner_02.png?v=1750057717'
        },
        {
            id: 'Slide-template--24335250194711__slideshow_r397Hj-2',
            mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/Yarnen-banners-6.2.jpg?v=1746796370'
        },
        {
            id: 'Slide-template--24335250194711__slideshow_r397Hj-3',
            mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/Yarnen-banners6.3.jpg?v=1746796369'
        },
        {
            id: 'Slide-template--24335250194711__slideshow_r397Hj-4',
            mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/Yarnen-banners-6.4.jpg?v=1746796369'
        },
        {
            id: 'Slide-template--24335250194711__slideshow_r397Hj-5',
            mobileImg: 'https://cdn.shopify.com/s/files/1/0931/8347/5991/files/Yarnen-banners-6.1.jpg?v=1746796369'
        }
    ];

    function updateSlideImages() {
        const isMobile = window.innerWidth < mobileWidth;
        
        slides.forEach(slide => {
            const slideElement = document.getElementById(slide.id);
            if (slideElement) {
                const imgElement = slideElement.querySelector('img');
                if (imgElement) {
                    if (isMobile) {
                        imgElement.src = slide.mobileImg;
                        imgElement.srcset = `${slide.mobileImg} 375w, ${slide.mobileImg} 550w, ${slide.mobileImg} 750w`;
                    } else {
                        // Restore original images for desktop (you may need to adjust these URLs to match your original desktop images)
                        const originalSrc = imgElement.getAttribute('data-original-src') || imgElement.src;
                        imgElement.src = originalSrc;
                        imgElement.srcset = imgElement.getAttribute('data-original-srcset') || imgElement.srcset;
                    }
                }
            }
        });
    }

    // Store original image sources
    slides.forEach(slide => {
        const slideElement = document.getElementById(slide.id);
        if (slideElement) {
            const imgElement = slideElement.querySelector('img');
            if (imgElement) {
                imgElement.setAttribute('data-original-src', imgElement.src);
                imgElement.setAttribute('data-original-srcset', imgElement.srcset);
            }
        }
    });

    // Initial check
    updateSlideImages();

    // Update on window resize
    window.addEventListener('resize', updateSlideImages);
});

// Accordion
 function toggleAccordion(header) {
            const content = header.nextElementSibling;
            header.classList.toggle('collapsed');
            content.classList.toggle('collapsed');
        }